import { useQuery, useMutation } from "@tanstack/react-query";
import { fetch2, fetch3, fetch4 } from "../commonApis/commonApis";

const url = process.env.REACT_APP_BASE_URL || "";

export const useParseCustomImportMutation = () => {
  return useMutation({
    mutationFn: async (payload: { file: File; merchantId?: string; sheetName?: string }) => {
      const formData = new FormData();
      formData.append("file", payload.file);
      if (payload.merchantId) formData.append("merchantId", payload.merchantId);
      if (payload.sheetName) formData.append("sheetName", payload.sheetName);

      const res = await fetch2(`${url}/api/v1/custom-import/parse`, formData);
      if (!res || res.success === false || !res.data) {
        throw new Error(res?.message || res?.error || "Failed to parse order sheet");
      }
      return res.data;
    },
  });
};

export const usePreviewCustomImportMutation = () => {
  return useMutation({
    mutationFn: async (payload: {
      file: File;
      mappingConfig: Record<string, string>;
      merchantId: string;
      warehouseId: string;
      sheetName?: string;
      defaultPaymentType?: string;
    }) => {
      const formData = new FormData();
      formData.append("file", payload.file);
      formData.append("mappingConfig", JSON.stringify(payload.mappingConfig));
      formData.append("merchantId", payload.merchantId);
      formData.append("warehouseId", payload.warehouseId);
      if (payload.sheetName) formData.append("sheetName", payload.sheetName);
      if (payload.defaultPaymentType) formData.append("defaultPaymentType", payload.defaultPaymentType);

      const res = await fetch2(`${url}/api/v1/custom-import/preview`, formData);
      if (!res || res.success === false || !res.data) {
        throw new Error(res?.message || res?.error || "Failed to generate preview");
      }
      return res.data;
    },
  });
};

export const useExecuteCustomImportMutation = () => {
  return useMutation({
    mutationFn: async (payload: {
      rows: any[];
      merchantId: string;
      warehouseId: string;
      sourceChannel?: string;
      orderType?: string;
      fulfillmentType?: string;
      fileName?: string;
    }) => {
      const res = await fetch4(`${url}/api/v1/custom-import/execute`, payload);
      if (!res || res.success === false) {
        throw new Error(res?.message || res?.error || "Import execution failed");
      }
      return res.data;
    },
  });
};

export const useFetchImportTemplates = (merchantId?: string) => {
  return useQuery({
    queryKey: ["importTemplates", merchantId],
    queryFn: async () => {
      const param = merchantId ? `?merchantId=${merchantId}` : "";
      const res = await fetch3(`${url}/api/v1/custom-import/templates${param}`, "get");
      return res.data;
    },
    enabled: true,
  });
};

export const useSaveImportTemplateMutation = () => {
  return useMutation({
    mutationFn: async (payload: {
      templateName: string;
      merchantId?: string;
      sourceChannel?: string;
      mappingConfig: Record<string, string>;
    }) => {
      const res = await fetch4(`${url}/api/v1/custom-import/templates`, payload);
      return res.data;
    },
  });
};

export const useFetchImportHistory = (merchantId?: string) => {
  return useQuery({
    queryKey: ["importHistory", merchantId],
    queryFn: async () => {
      const param = merchantId ? `?merchantId=${merchantId}` : "";
      const res = await fetch3(`${url}/api/v1/custom-import/history${param}`, "get");
      return res.data;
    },
  });
};
